<template>
  <div class="w-full">
    <MediaFooter />
  </div>
</template>

<script>
import MediaFooter from "@/components/footer/socials/MediaFooter.vue";

export default {
  components: {
    MediaFooter
  },
  data() {
    return {
      logo: require("@/assets/img/SVG/pushlogo.svg"),
      Products: [
        {
          title: "Products",
          links: [
            {
              link: "/features",
              name: "Features"
            },
            {
              link: "/demo",
              name: "Request a demo"
            },
            {
              link: "/Support",
              name: "Support"
            }
          ]
        }
      ],
      Pricing: [
        {
          title: "Pricing",
          links: [
            {
              link: "/Billing",
              name: "Billing"
            },
            {
              link: "/freetrial",
              name: "Free trial"
            }
          ]
        }
      ],
      Company: [
        {
          title: "Company",
          links: [
            {
              link: "/blog",
              name: "Blog"
            },
            {
              link: "/ContactUs",
              name: "Contact us"
            }
          ]
        }
      ]
    };
  }
};
</script>
